<template>
  <dialog-v2
    :show="showDialog"
    :title="dialogTitle"
    :disable-save-btn="isManualCallLoading"
    save-button-text="Iniciar"
    max-width="600px"
    @close="closeDialog"
    @save="saveDialog">
    <template slot="content">
      <v-layout mb-3>
        <!-- <v-flex md4  offset-md1>
          <v-btn outline flat class="w-100 call-type-btn ma-0" @click="form.call_type = 'colektia'">
            <img src="https://assets.website-files.com/5e67f74a495c76eb16065e0a/5e6be103049b8a73198f2fc3_Colektia%20logo%20rgb%20-%20png%20-%20900x400px%20-%20300dpi%20-%20color.png" width="160px">
            <v-icon v-if="form.call_type === 'colektia'" small icon color="green">
              fas fa-check-circle
            </v-icon>
          </v-btn>
        </v-flex> -->
        <v-flex md4 offset-md4>
          <v-btn outline flat class="w-100 call-type-btn ma-0" @click="form.call_type = 'softphone'">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRujJauFiE7lLurvdinpyVBK6Sa6w2V7sLTk5RhlMdt_iWqM37GizsUB62ByrxxC2u9qA&usqp=CAU" width="160px">
            <v-icon v-if="form.call_type === 'softphone'" small icon color="green">
              fas fa-check-circle
            </v-icon>
          </v-btn>
          <!-- <v-switch
            v-if="form.call_type === 'softphone'"
            label="Wireguard"
            v-model="form.new_server"
            class="k-blue-linear-text"
            :hide-details="true"/> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="form.call_type === 'softphone'">
        <v-flex>
          <v-text-field
            v-model="form.extension_number"
            v-validate="'required'"
            data-vv-name="extension_number"
            data-vv-scope="callCustomerStart"
            data-vv-as="extension"
            color="black"
            label="Extension"
            :error-messages="errors.collect('callCustomerStart.extension_number')"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    disableSaveBtn: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      call_type: '',
      extension_number: '',
      new_server: false,
    };
    return {
      showDialog: false,
      emptyForm,
      form: _.cloneDeep(emptyForm),
    };
  },
  computed: {
    dialogTitle() {
      return 'Seleccione';
    },
    isManualCallLoading() {
      return this.$store.state.dialer.isManualCallLoading;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
      setTimeout(() => {
        this.form = _.cloneDeep(this.emptyForm);
      }, 300);
    },
    saveDialog() {
      this.$validator.validateAll('callCustomerStart')
        .then((validation) => {
          if (validation && this.form.call_type) {
            this.$emit('save', this.form);
          }
        });
    },
  },
  watch: {
    show() {
      this.showDialog = this.show;
    },
    'form.call_type'() {
      if (this.form.call_type !== 'softphone') {
        this.form.new_server = false;
      }
    },
  },
};
</script>

<style scoped>
.call-type-btn {
  height: 200px !important;
  border: 1px solid #000;
  border-radius: 5px;
  color: rgba(128, 128, 128, 0.72);
  position: relative;
}
.call-type-btn i {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/Individual.vue